import { useInfiniteQuery } from '@tanstack/react-query';
import useSlingApi from '@sdk/api/useSlingApi';

import { REFETCH_INTERVAL } from '@web/announcements/consts/cache';
import { getAnnouncementsQueryKey } from '@web/announcements/utils/getQueryKey';
import { mapAnnouncements } from '@web/announcements/utils/mappers';

const PAGE_SIZE = 200;

export const useGetAnnouncements = () => {
  const { announcements } = useSlingApi();
  const queryKey = getAnnouncementsQueryKey();

  const result = useInfiniteQuery({
    queryKey,
    queryFn: async ({ pageParam }) => {
      const { data } = await announcements.list({
        pageSize: PAGE_SIZE,
        beforeId: pageParam,
      });

      return mapAnnouncements(data);
    },
    getNextPageParam: (lastPage) => {
      const lastPageLength = lastPage.length;
      const hasLoadedAllItems = lastPageLength < PAGE_SIZE;

      if (hasLoadedAllItems) return undefined;

      return lastPage[lastPageLength - 1].id;
    },
    refetchInterval: REFETCH_INTERVAL,
  });

  return result;
};
